<template>
  <BTable
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <!--  -->

    <template #item.status="{ data, value: v }">
      <LKButtonReport
        :status="v.status"
        :url="v.url"
        :filename="v.filename"
        :tooltip="v.tooltip"
        @click="$emit('update:status', data, $event)"
      />
    </template>

    <!--  -->
  </BTable>
</template>

<script>
import {
  TABLE_ACTIONS,
  TABLE_HEADERS,
} from '@/views/LKReports/table-headers'
import BTableSimple from './BTableSimple.vue'
import LKButtonReport from '@/components/lk/LKButtonReport.vue'


export default {
  name: 'BTableReports',
  components: {
    LKButtonReport,
  },
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>
